import { render, staticRenderFns } from "./RegisterType.vue?vue&type=template&id=d2d73312&scoped=true"
import script from "./RegisterType.vue?vue&type=script&lang=js"
export * from "./RegisterType.vue?vue&type=script&lang=js"
import style0 from "./RegisterType.vue?vue&type=style&index=0&id=d2d73312&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d73312",
  null
  
)

export default component.exports